import { render, staticRenderFns } from "./StoreSettingsGeneral.vue?vue&type=template&id=e50aae06&"
import script from "./StoreSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./StoreSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports